import Otty from '@luketclancy/otterly/otty'
import morphdom from 'morphdom'

export default class extends Otty {
	async waitForImages(){
		let arr = Array.from(document.body.querySelectorAll('img')).map((im)=>{
			new Promise((resolve) => {
				im.addEventListener('load', resolve)
				if(im.complete){resolve()}
			})
		})
		for(let a of arr){await a}
		return true
	}

	async pageReplace(tempdoc, scroll, url){
		let befY = window.scrollY
		
		//standardize tempdoc (accept strings)
		if(typeof tempdoc == "string") {
			tempdoc = (new DOMParser()).parseFromString(tempdoc,  "text/html")
		}

		//switch the document's this.navigationReplace's css selector elements. if either not found,
		//default to switching bodies entirely
		let tmpOrienter, orienter,  replaceSelector
		for(replaceSelector of this.navigationReplaces){
			// console.log(tempdoc, replaceSelector)
			tmpOrienter = tempdoc.querySelector(replaceSelector)	
			orienter = document.querySelector(replaceSelector)
			if(tmpOrienter && orienter) {
				break
			}
		}

		//been having issues with the removed thing triggering.
		//this will do it manually, and then remove the el._unit so
		//it wont trigger again
		for(let unitEl of this.qsInclusive(orienter, '[data-unit]')){
			unitEl._unit?.unitRemoved()
		}
	
		//set stored information for recreating current page
		let storeDoc =  this.createStorageDoc(orienter, document.head)

		// orienter.replaceChildren(...tmpOrienter.children)
		orienter.replaceWith(tmpOrienter)

		//morph the head to the new head. Throw into a different function for
		//any strangeness that one may encounter and 
		this.navigationHeadMorph(tempdoc.querySelector('head'))

		let shouldScrollToEl = (url && (!scroll))
		
		//handle scrolling
		let scrolled = false
		if(shouldScrollToEl){
			scrolled = await this.scrollToLocationHashElement(url)
		}
		if(!scrolled){
			if(scroll != 0){await this.waitForImages()}
			window.scroll(0, scroll)
		}

		return {doc: storeDoc, befY, replaceSelector} // return the old element replaced
	}
	
	//this method has been changed to try and account for the insanity of the Table Of Contents.
	//Namely, it waits for any relevant editors to be loaded before it continues
	async scrollToLocationHashElement(loc){
		return new Promise(async(resolve) => {
			if(! loc.hash){ resolve(false) }

			let waitaway = Array.from(document.querySelectorAll('[data-hash-wait]'))

			for(let hw of waitaway) {
				// console.log(hw, hw._unit)
				if(hw?._unit?.editorLoadedPromise){
					await hw._unit.editorLoadedPromise	
				}
			}

			let e = document.getElementById(decodeURIComponent(loc.hash.slice(1)))
			if(e){
				await this.waitForImages()
				e.scrollIntoView()
				resolve(true)
			}
			resolve(false)
		})
	}
	//this method has been changed so that even if we cant find the hash, we 
	//dont leave the page
	async stopGoto(href){
		return new Promise(async (resolve) => {
			//Check scroll to hash on same page
			let loc = window.location
			href = new URL(href, loc)
			//hashes
			if(loc.origin == href.origin && href.pathname == loc.pathname && href.hash){
				await this.scrollToLocationHashElement(href)
				resolve(true)
			}
			//I wanted my subdomains to be counted too... apparently not possible...
			if(loc.origin != href.origin){
				window.location.href = href.origin
				resolve(true)
			}
			resolve(false)
		})
	}
}